/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorDataFilter', 'model/PerformanceIndicatorWeekData', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicatorDataFilter'), require('../model/PerformanceIndicatorWeekData'), require('../model/CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorWeekDataApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorDataFilter, root.ForStractionServiceApi.PerformanceIndicatorWeekData, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, PerformanceIndicatorDataFilter, PerformanceIndicatorWeekData, CorporateStructureLink) {
  'use strict';

  /**
   * PerformanceIndicatorWeekData service.
   * @module api/PerformanceIndicatorWeekDataApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorWeekDataApi. 
   * @alias module:api/PerformanceIndicatorWeekDataApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorWeekDataClearPut operation.
     * @callback module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataClearPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clear
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDataFilter>} body 
     * @param {module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataClearPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorWeekDataClearPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorWeekDataClearPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorWeekDataClearPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorWeekData/clear', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorWeekDataMergeAllPut operation.
     * @callback module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorWeekData>} body 
     * @param {Boolean} rollOverLevels 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.aggregationLevelID 
     * @param {module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.performanceIndicatorWeekDataMergeAllPut = function(_4SAPIAppID, body, rollOverLevels, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorWeekDataMergeAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorWeekDataMergeAllPut";
      }

      // verify the required parameter 'rollOverLevels' is set
      if (rollOverLevels == undefined || rollOverLevels == null) {
        throw "Missing the required parameter 'rollOverLevels' when calling performanceIndicatorWeekDataMergeAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'rollOverLevels': rollOverLevels,
        'aggregationLevelID': opts['aggregationLevelID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/PerformanceIndicatorWeekData/mergeAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorWeekDataMergeTargetActualValuePut operation.
     * @callback module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetActualValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetActualValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} week 
     * @param {Integer} indicatorID 
     * @param {Number} actual 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetActualValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorWeekDataMergeTargetActualValuePut = function(_4SAPIAppID, body, year, week, indicatorID, actual, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorWeekDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorWeekDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorWeekDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'week' is set
      if (week == undefined || week == null) {
        throw "Missing the required parameter 'week' when calling performanceIndicatorWeekDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorWeekDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'actual' is set
      if (actual == undefined || actual == null) {
        throw "Missing the required parameter 'actual' when calling performanceIndicatorWeekDataMergeTargetActualValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'week': week,
        'indicatorID': indicatorID,
        'actual': actual,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorWeekData/mergeTargetActualValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorWeekDataMergeTargetBudgetValuePut operation.
     * @callback module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetBudgetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetBudgetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} week 
     * @param {Integer} indicatorID 
     * @param {Number} budget 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetBudgetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorWeekDataMergeTargetBudgetValuePut = function(_4SAPIAppID, body, year, week, indicatorID, budget, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorWeekDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorWeekDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorWeekDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'week' is set
      if (week == undefined || week == null) {
        throw "Missing the required parameter 'week' when calling performanceIndicatorWeekDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorWeekDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'budget' is set
      if (budget == undefined || budget == null) {
        throw "Missing the required parameter 'budget' when calling performanceIndicatorWeekDataMergeTargetBudgetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'week': week,
        'indicatorID': indicatorID,
        'budget': budget,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorWeekData/mergeTargetBudgetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorWeekDataMergeTargetForecastValuePut operation.
     * @callback module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetForecastValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetForecastValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} week 
     * @param {Integer} indicatorID 
     * @param {Number} forecast 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetForecastValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorWeekDataMergeTargetForecastValuePut = function(_4SAPIAppID, body, year, week, indicatorID, forecast, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorWeekDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorWeekDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorWeekDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'week' is set
      if (week == undefined || week == null) {
        throw "Missing the required parameter 'week' when calling performanceIndicatorWeekDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorWeekDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'forecast' is set
      if (forecast == undefined || forecast == null) {
        throw "Missing the required parameter 'forecast' when calling performanceIndicatorWeekDataMergeTargetForecastValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'week': week,
        'indicatorID': indicatorID,
        'forecast': forecast,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorWeekData/mergeTargetForecastValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorWeekDataMergeTargetGoalValuePut operation.
     * @callback module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetGoalValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetGoalValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} week 
     * @param {Integer} indicatorID 
     * @param {Number} goal 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetGoalValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorWeekDataMergeTargetGoalValuePut = function(_4SAPIAppID, body, year, week, indicatorID, goal, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorWeekDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorWeekDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorWeekDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'week' is set
      if (week == undefined || week == null) {
        throw "Missing the required parameter 'week' when calling performanceIndicatorWeekDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorWeekDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'goal' is set
      if (goal == undefined || goal == null) {
        throw "Missing the required parameter 'goal' when calling performanceIndicatorWeekDataMergeTargetGoalValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'week': week,
        'indicatorID': indicatorID,
        'goal': goal,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorWeekData/mergeTargetGoalValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorWeekDataMergeTargetValuePut operation.
     * @callback module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} week 
     * @param {Integer} indicatorID 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.actual 
     * @param {Number} opts.goal 
     * @param {Number} opts.budget 
     * @param {Number} opts.forecast 
     * @param {Integer} opts.sourceID 
     * @param {Object.<String, {String: String}>} opts.resources 
     * @param {module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataMergeTargetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorWeekDataMergeTargetValuePut = function(_4SAPIAppID, body, year, week, indicatorID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorWeekDataMergeTargetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorWeekDataMergeTargetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorWeekDataMergeTargetValuePut";
      }

      // verify the required parameter 'week' is set
      if (week == undefined || week == null) {
        throw "Missing the required parameter 'week' when calling performanceIndicatorWeekDataMergeTargetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorWeekDataMergeTargetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'week': week,
        'indicatorID': indicatorID,
        'actual': opts['actual'],
        'goal': opts['goal'],
        'budget': opts['budget'],
        'forecast': opts['forecast'],
        'sourceID': opts['sourceID'],
        'resources': opts['resources']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorWeekData/mergeTargetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorWeekDataSearchPut operation.
     * @callback module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorWeekData>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorWeekData>} body 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.startDate 
     * @param {Date} opts.endDate 
     * @param {module:api/PerformanceIndicatorWeekDataApi~performanceIndicatorWeekDataSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorWeekData>}
     */
    this.performanceIndicatorWeekDataSearchPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorWeekDataSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorWeekDataSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startDate': opts['startDate'],
        'endDate': opts['endDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorWeekData];

      return this.apiClient.callApi(
        '/PerformanceIndicatorWeekData/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
